/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Subscription_Price_Early_BirdInputs */

const en_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const ar_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const de_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const es_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const fr_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const it_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const ja_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const ko_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const pt_br_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const ru_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const th_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const tr_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (Early Bird price)`)
};

const zh_cn_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (早鸟价)`)
};

const zh_tw_subscription_price_early_bird = /** @type {(inputs: Subscription_Price_Early_BirdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} (早鸟价)`)
};

/**
* | output |
* | --- |
* | "{price} (Early Bird price)" |
*
* @param {Subscription_Price_Early_BirdInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_price_early_bird = /** @type {((inputs: Subscription_Price_Early_BirdInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Price_Early_BirdInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_price_early_bird(inputs)
	if (locale === "ar") return ar_subscription_price_early_bird(inputs)
	if (locale === "de") return de_subscription_price_early_bird(inputs)
	if (locale === "es") return es_subscription_price_early_bird(inputs)
	if (locale === "fr") return fr_subscription_price_early_bird(inputs)
	if (locale === "it") return it_subscription_price_early_bird(inputs)
	if (locale === "ja") return ja_subscription_price_early_bird(inputs)
	if (locale === "ko") return ko_subscription_price_early_bird(inputs)
	if (locale === "pt_br") return pt_br_subscription_price_early_bird(inputs)
	if (locale === "ru") return ru_subscription_price_early_bird(inputs)
	if (locale === "th") return th_subscription_price_early_bird(inputs)
	if (locale === "tr") return tr_subscription_price_early_bird(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_price_early_bird(inputs)
	return zh_tw_subscription_price_early_bird(inputs)
});